import { selectTradeInNewWidgetCalculator } from '../common/selectors';

export const selectTradeInMaxPriceState = (state) =>
  selectTradeInNewWidgetCalculator(state).maxPrice;

export const selectTradeInMaxPriceValue = (state): number =>
  selectTradeInMaxPriceState(state)?.data;

export const getTradeInDeviceMaxPrice = (state) =>
  `${selectTradeInMaxPriceValue(state) || 0}`;
